import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const SubscriptionPackage = async (PujaKeyID, AppLangID) => {
    let url = ""
    if (AppLangID === null || AppLangID === undefined || AppLangID === "") {
        url = `${NewUpdatedBaseUrl}/SubscriptionPackage/GetPujaSubscriptionPackageListByPujaKeyID?PujaKeyID=${PujaKeyID}`;
    } else {
        url = `${NewUpdatedBaseUrl}/SubscriptionPackage/GetPujaSubscriptionPackageListByPujaKeyID?PujaKeyID=${PujaKeyID}&AppLangID=${AppLangID}`;
    }

    const res = await getApiWithAuthorization(url);

    return res;
};